<template>
    <div class="report">
      <div class="report-content">
        <router-view></router-view>
      </div>
      <img class="report-icon" src="../../../assets/content-box.png"/>
    </div>
</template>

<script>
export default {
  name: 'historyData',
  data () {
    return {}
  }
}
</script>

<style scoped>
 @import "historyData.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/historyData/historyData.vue